const constants = require('@/util/constants')

export default {
    categories: [],
    current_category: {
        id: 0,
        cid: '',
        name: ''
    },
    articles: {
        content: [],
        empty: false,
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        totalPages: 0,
        totalElements: 0
    },
    current_article: {
        aid: '',
        title: '',
        summary: '',
        content: ''
    },
    knowledgebase: {
        kid: '',
        name: '知识库',
        headline: '标题',
        language: 'zh',
        subDomain: '',
        url: '',
        logo: '',
        favicon: 'https://cdn.bytedesk.com/kb/assets/img/favicon.png',
        primaryColor: '#02b3e4',
        description: '',
        header: '',
        footer: '',
        css: '',
        showKeFu: false,
        appointed: false,
        type: 'workgroup',
        workGroupWid: '',
        agentUid: ''
    }
}
